import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrl: './filter.component.css',
})
export class FilterComponent {
    @Input() form: FormGroup;
    @Input() filters: any;
    @Input() showAdvancedFilters: boolean;
    @Input() sessionUser$: any;
    @Input() productFieldKey: string;
    @Input() businessFieldKey: string;
    @Input() supplierFieldKey: string;
    @Input() presetRanges: any;
    @Input() searchItems: any;
    @Input() storeFieldKey: string; // Used in the template
    @Input() provinceFieldKey: string; // Used in the template
    @Input() wholesalerFieldKey: string;
    @Input() categoryFieldKey: string; // Optional: only rendered when a consumer binds this

    @Output() submitSearch = new EventEmitter<string>();
    @Output() clear = new EventEmitter<void>();
    @Output() onChangeEvent = new EventEmitter<{ event: any; key: string }>();
    @Output() onClearEvent = new EventEmitter<string>();
    @Output() toggle = new EventEmitter<void>();
    @Output() removeItem = new EventEmitter<{ key: string; item: string }>();
    @Input() isClearing = false;
    onRangeChange(event: any) {
        if (event && event.startDate && event.endDate) {
            this.form.patchValue({
                fromDateFilter: event.startDate,
                toDateFilter: event.endDate,
            });
        } else {
            this.form.patchValue({
                fromDateFilter: null,
                toDateFilter: null,
            });
        }
        if (!this.isClearing) {
            this.submitSearch.emit('fromDate,toDate');
        }
    }

    emitChange(event: any, key: string) {
        if (this.isClearing) return;
        this.onChangeEvent.emit({ event, key });
        if (key === this.provinceFieldKey && (!event || event.length === 0)) {
            this.form.get(this.wholesalerFieldKey)?.setValue([]);
            this.form.get(this.storeFieldKey)?.setValue([]);
        }
        if (!this.isClearing) {
            this.submitSearch.emit(key);
        }
    }

    emitClear(key: string) {
        this.onClearEvent.emit(key);
        if (key === this.provinceFieldKey) {
            this.form.get(this.wholesalerFieldKey)?.setValue([]);
            this.form.get(this.storeFieldKey)?.setValue([]);
        }
    }

    removeSearch(key: string, item: string) {
        this.removeItem.emit({ key, item });
        if (key === this.provinceFieldKey) {
            const provinces = this.form.get(this.provinceFieldKey)?.value;
            if (!provinces || provinces.length === 0) {
                this.form.get(this.wholesalerFieldKey)?.setValue([]);
                this.form.get(this.storeFieldKey)?.setValue([]);
            }
        }

        if (!this.isClearing) {
            this.submitSearch.emit(key);
        }
    }
}
